<div #dialog *ngIf="isModalActive">
  <!-- Modal Header -->
  <ng-container *ngIf="(loaded$ | async); else loading">
    <div class="cx-dialog-header modal-header">
      <span class="cx-dialog-title modal-title">
        {{'addToCart.successfullyAddedToYourCart' | mbTranslate }}
      </span>
      <button class="close-modal"
              title="Close"
              (click)="closeDialog('Close modal')">
      </button>
    </div>
    <!-- Modal Body -->
    <div class="cx-dialog-body modal-body" *ngIf="entry$ | async as entry">
      <div class="cx-dialog-row">
        <div class="mb-popup-product-details">
          <div class="mb-popup-media">
            <cx-media [container]="entry.product?.images?.PRIMARY"
                      format="product"
                      alt="Cart Icon">
            </cx-media>
          </div>
          <div class="d-flex flex-column w-100">
            <div class="mb-popup-product-description-wrapper">
              <div class="mb-popup-product-description">
                <div class="mb-popup-product-code"
                    [mbCopyToClipboard]="entry.product?.code"
                    mbShowPopup>
                  <mb-clipboard-popup role="tooltip" data-cy="mb-show-clipboard-popup"></mb-clipboard-popup>
                  <strong [innerHTML]="entry.product?.code | safeHtml"></strong>
                </div>
                <div>
                  <span class="mb-popup-product-name"
                        [innerHTML]="entry.product.nameHtml | safeHtml"></span>
                  <span *ngIf="entry.product.clinicalReferenceNumber"
                        class="ml-1"
                        [innerHTML]="'(' + entry.product.clinicalReferenceNumber + ')'| safeHtml"></span>
                </div>
                <div *ngIf="entry.product.regulatoryStatus"
                      class="mb-popup-regulatory-status py-1"
                      [innerHTML]="entry.product.regulatoryStatus | safeHtml"></div>
                <ng-container *ngIf="entry.orderEntryType !== constants.PRICE_REQUEST">
                  <div class="mb-price">
                    <span [innerHTML]="'addToCartPopup.price' | mbTranslate"></span>
                    <span>{{entry.basePrice?.formattedValue}}</span>
                  </div>
                </ng-container>
              </div>
              <div class="mb-popup-product-quantity">
                <mb-quantity-counter [control]="getQuantityControl() | async"
                                    [max]="maxItemQuantity"
                                    [min]="1">
                </mb-quantity-counter>
                <div class="mb-sub-title">
                  <ng-container *ngIf="entry.orderEntryType !== constants.PRICE_REQUEST">
                    <span [innerHTML]="'addToCartPopup.total' | mbTranslate"></span>
                    <span>{{entry.totalPrice.formattedValue}}</span>
                  </ng-container>
                  <ng-container *ngIf="entry.orderEntryType === constants.PRICE_REQUEST">
                    <span [innerHTML]="'mbcommon.priceOnRequest' | mbTranslate"></span>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="mb-notification">
              <ng-container *ngIf="isCartAdjusted; else tCartNotAdjusted">
                <spann class="warning">
                  {{'addToCart.maxItemQuantityReached' | mbTranslate : {maxItemQuantity} }}
                </spann>
              </ng-container>
              <ng-template #tCartNotAdjusted>
                <div class="success-container">
                  <div class="icon-container">
                    <img src="/assets/icons/svg/check-mark.svg" alt="check-mark-icon" height="16">
                  </div>
                  <div class="success">
                    {{((addedEntryWasMerged$| async) && 'addToCart.itemsIncrementedInYourCart' || 'addToCartPopup.productsAddedToYourCart') | mbTranslate}}
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="w-100 p-3">
          <mb-add-to-cart-dialog-teaser-component
            [entry]="entry$ | async"
            [dataAnalyticsClickSource]="dataAnalyticsClickSource"
            [dataAnalyticsEventLabel]="dataAnalyticsEventLabel"
          ></mb-add-to-cart-dialog-teaser-component>
        </div>
        <div class="cx-dialog-actions w-100">
          <button [class.disabled]="form.dirty"
                  cxModal="dismiss"
                  cxModalReason="Continue Shopping click"
                  class="btn btn-primary"
                  (click)="closeDialog('Continue Shopping click')"
                  [innerHTML]="'addToCartPopup.continueShopping' | mbTranslate">
          </button>
          <div class="cart-actions">
            <ng-container *ngIf="cart$ | async as cart">
              <div class="cx-dialog-total">
                <span>
                  {{
                    'cartItems.cartTotal' | cxTranslate: { count: cart.deliveryItemsQuantity }
                  }}
                </span>
                <span class="ml-auto"
                      *ngIf="!(isRequestCheckoutType$ | async)">
                  {{ cart.subTotal?.formattedValue }}
                </span>
                <span *ngIf="isRequestCheckoutType$ | async"
                      [innerHTML]="'mbcommon.priceOnRequest' | mbTranslate"
                      class="ml-auto">
                </span>
              </div>
            </ng-container>
            <a [class.disabled]="form.dirty"
               [routerLink]="{ cxRoute: 'cart' } | cxUrl"
               cxModal="dismiss"
               cxModalReason="View Cart click"
               class="btn btn-secondary"
               autofocus
               [innerHTML]="'addToCartPopup.viewCart' | mbTranslate">
            </a>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title"
           [innerHTML]="'addToCart.updatingCart' | mbTranslate">
      </div>
    </div>
    <!-- Modal Body -->
    <div class="cx-dialog-body modal-body">
      <div class="cx-dialog-row">
        <div class="col-sm-12">
          <cx-spinner></cx-spinner>
        </div>
      </div>
    </div>
  </ng-template>
</div>
